import React from 'react';
import { createRoot } from 'react-dom/client';
import type { Root } from 'react-dom/client';

type Props = {
  children: React.ReactNode;
};

class RenderInBody extends React.Component<Props>
{
  private item: HTMLDivElement | null = null;
  private root: Root | null = null;

  constructor(props: Props)
  {
    super(props);
    this.renderItem = this.renderItem.bind(this);
  }

  componentDidMount()
  {
    this.item = document.createElement('div');
    document.body.appendChild(this.item);

    this.root = createRoot(this.item);
    this.renderItem();
  }

  componentDidUpdate()
  {
    this.renderItem();
  }

  componentWillUnmount(): void
  {
    if (this.root)
    {
      const root = this.root;
      const item = this.item;
      this.root = null;
      this.item = null;
      // Defer unmount to avoid calling it synchronously during React's render cycle,
      // which triggers a React 18 warning/error.
      setTimeout(() =>
      {
        root.unmount();
        item?.remove();
      });
    }
    else
    {
      this.item?.remove();
      this.item = null;
    }
  }

  renderItem()
  {
    if (!this.root) return;

    this.root.render(<>{this.props.children}</>);
  }

  render()
  {
    return null;
  }
}

export default RenderInBody;
